import { Dispatch } from 'redux';
import fetchApi from '../services/api';
import * as types from './actionTypes';
import { forceLoginHelper } from './auth';
import { setFirstOfferSubmitted } from './dashboard';

/**
 * Fetch all offers made by a user
 * @param {string} token - The user's authentication token
 */
export function fetchOffers(token: string) {
  return async (dispatch: Dispatch<any>) => {
    dispatch({
      type: types.ClearMessages,
    });
    try {
      const response = await fetchApi('/offers', {}, 'get', {}, token);
      const json = await response.json();
      if (response.ok) {
        if (json.results.length > 0) {
          dispatch(setFirstOfferSubmitted());
        }
        dispatch({
          type: types.OffersFetchSuccess,
          offers: json.results,
          messages: [json],
        });
      } else {
        dispatch(
          forceLoginHelper(json, () => {
            dispatch({
              type: types.OffersFetchFailure,
              messages: [json],
            });
          }),
        );
      }
    } catch (error) {
      dispatch({
        type: types.GenericError,
        error,
      });
    }
  };
}
